import { serviceRoles } from "config/access";
import { TEMPLATES } from "constants/routes";
import { checkAccess } from "helpers/auth";
import ProjectPage from "./container/TemplatesPage";

export default function getSettingsRoute(userAuth) {
  const { account, rhapsody } = serviceRoles;
  const requireAuth = {
    [rhapsody.name]: [account.roles.user],
    [account.name]: [account.roles.superadmin],
  };
  return {
    requireAuth,
    onEnter: () => checkAccess(requireAuth, userAuth),
    path: TEMPLATES,
    withSidebar: true,
    withAppBar: true,
    component: ProjectPage,
  };
}
